// extracted by mini-css-extract-plugin
export default {"dotRepeat":"WbsOption_dotRepeat__ZnTA2"};